export class CALENDAR_REPEAT_ON_DAYS {
  static Never = 0;
  static Monday = 1;
  static Tuesday = 2;
  static Wednesday = 4;
  static Thursday = 8;
  static Friday = 16;
  static Saturday = 32;
  static Sunday = 64;
}
